module.exports = __webpack_public_path__ + "static/media/square-x-twitter.8bd24fa1.svg";